export type FormValue = string | boolean | null | undefined;

export enum ControllerEvent {
    NONE = 'none',
    NEXT = 'next',
    PENDING = 'pending',
    PREVIOUS = 'previous',
    SAVE = 'save',
    SAVE_QUESTION = 'saveQuestion',
}

export enum ModalMode {
    CLOSED = 'closed',
    HINT = 'hint',
    WHY = 'why',
    RESULTS_WITHOUT_QUESTION = 'results_without_question',
}
